// (function () {
//     'use strict';

//     angular.module("imApp").factory("businessSService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listBusinessViews: function (parms) {
//                 return $ihttp.post({
//                     method: 1142,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
